import { useLayoutEffect, useRef } from 'react';

import { NavLink, Link } from 'react-router-dom';

import { classNames } from '@/utils/classNames';

import { PageContainer } from '@/components/layout/PageContainer/PageContainer';

import styles from '@/styles/layout.module.css';

export function AppHeader(): JSX.Element {
  const headerRef = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const header = headerRef.current;

    if (!header) {
      return;
    }

    const root = document.documentElement;

    const updateHeaderHeight = (): void => {
      root.style.setProperty('--app-header-height', `${Math.round(header.getBoundingClientRect().height)}px`);
    };

    updateHeaderHeight();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateHeaderHeight);

      return () => {
        window.removeEventListener('resize', updateHeaderHeight);
        root.style.removeProperty('--app-header-height');
      };
    }

    const observer = new ResizeObserver(() => updateHeaderHeight());
    observer.observe(header);

    return () => {
      observer.disconnect();
      root.style.removeProperty('--app-header-height');
    };
  }, []);

  return (
    <header ref={headerRef} className={styles.header}>
      <PageContainer className={styles.headerInner}>
        <Link to="/" className={styles.brandLink} aria-label="Ir para o início">
          <img
            className={styles.brandLogo}
            src="/logos/logos_verde_confirma.webp"
            alt="Verde Confirma"
            width={248}
            height={72}
            loading="eager"
            decoding="async"
          />
        </Link>

        <nav className={styles.nav} aria-label="Principal">
          <NavLink
            to="/"
            end
            className={({ isActive }) => classNames(styles.navLink, isActive && styles.navLinkActive)}
          >
            Início
          </NavLink>
          <NavLink
            to="/match-politico"
            className={({ isActive }) => classNames(styles.navLink, isActive && styles.navLinkActive)}
          >
            Match Político
          </NavLink>
        </nav>
      </PageContainer>
    </header>
  );
}
